import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { IRecipient, RecipientsState } from 'store/recipients/types';

export const getRecipientsState = (state: RootState): RecipientsState => state.recipients;

export const getRecipientsData = createSelector(
  [getRecipientsState],
  (state: RecipientsState): IRecipient[] => {
    if (!state.data?.recipients) return [];

    return state.data.recipients.map(recipient => {
      if (recipient.race?.election?.contribution_limit) {
        return {
          ...recipient,
          race: {
            ...recipient.race,
            election: {
              ...recipient.race.election,
              contribution_limit: String(Number(recipient.race.election.contribution_limit) / 100),
            },
          },
        };
      }
      return recipient;
    });
  }
);
